// extracted by mini-css-extract-plugin
export default {"interactionHistory":"ccf-consumer-card-interactions-tab_interactionHistory__pz5LO","interactionsTabContainer":"ccf-consumer-card-interactions-tab_interactionsTabContainer__ufIYS"};